/* global axios */
import { msBaseUrl } from './microservicos';

export const crmPessoasAPI = {
  /**
   * Página da listagem de Pessoas.
   * @param {Number} accountId
   * @param {Object} filters
   * @param {Object} pagination { page (base 0), size }
   */
  getPage(accountId, filters = {}, { page = 0, size = 50 } = {}) {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== '' && v !== null)
    );
    return axios.get(`${msBaseUrl('crm', accountId)}/persons/page`, {
      params: { ...cleanFilters, page, size },
    });
  },

  /**
   * Get Person by ID
   */
  getById(id, accountId) {
    return axios.get(`${msBaseUrl('crm', accountId)}/persons/${id}`);
  },

  /**
   * Create a new Person
   */
  create(data, accountId) {
    return axios.post(`${msBaseUrl('crm', accountId)}/persons`, data);
  },

  /**
   * Update a Person
   */
  update(id, data, accountId) {
    return axios.put(`${msBaseUrl('crm', accountId)}/persons/${id}`, data);
  },

  /**
   * Update a Person's active/inactive status (admin only in the UI)
   */
  updateStatus(id, active, actorName, accountId) {
    return axios.patch(`${msBaseUrl('crm', accountId)}/persons/${id}/status`, {
      active,
      actorName,
    });
  },
};
